import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <div className="footer">
      <div className="container">
        <div className="col">
          <h4>RECORDS</h4>
          <p>Apply break a record </p>
          <p>The application process </p>
          <p>Invite an adjudicator </p>
          <p>Records NFT </p>
        </div>
        <div className="col">
          <h4>PRODUCTS</h4>
          <p>World Records Kids </p>
          <p>Educators </p>
          <p>Wild Things </p>
          <p>Books </p>
        </div>
        <div className="col">
          <h4>NEWS</h4>
          <p>Latest news </p>
          <p>Press centre </p>
          <p>Commercial news </p>
          <p>social media channels </p>
        </div>
        <div className="col">
          <h4>BUSINESS SOLUTIONS</h4>
          <p>Case studies</p>
          <p>Product launch strategies </p>
          <p>Creative campaign solutions </p>
          <p>brand marketing solutions</p>
        </div>
      </div>
    </div>
  );
};
export default Footer;
